import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import ConfirmationModal from "./ConfirmationModal";
import { actions } from "../../util/actions";

const GlobalErrorModal = () => {
  const dispatch = useDispatch();
  const { show, title, message, confirmLabel, status } = useSelector(
    (state) => state.ui.errorModal
  );

  const handleClose = useCallback(() => {
    dispatch({ type: actions.HIDE_ERROR_MODAL });
  }, [dispatch]);

  if (!show) return null;

  return (
    <ConfirmationModal
      show={show}
      title={title}
      message={message}
      status={status}
      single
      confirmLabel={confirmLabel}
      onConfirm={handleClose}
      onCancel={handleClose}
    />
  );
};

export default GlobalErrorModal;
